<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("number.pilot") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("number.pilot")}}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->
          <form>
            <div class="form-group row" v-if="isDtacAdmin">
              <label
                for="pilot-corporate"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("menu.corporate") }} *</label
              >
              <div class="col-md-10">
                <base-input
                  input-classes="form-control-alternative new-event--title"
                >
                  <el-select id="pilot-corporate"
                    v-model="create.corporate"
                    :placeholder="$t('menu.corporate')"
                    filterable
                  >
                    <el-option
                      v-for="option in corporate"
                      :key="option.label"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="form-group row" v-if="isDtacAdmin">
              <label
                for="pilot-type"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("number.type") }}</label
              >
              <div class="col-md-10">
                <base-input
                  input-classes="form-control-alternative new-event--title"
                >
                  <el-select id="pilot-type"
                    v-model="create.type"
                    :placeholder="$t('number.type')"
                  >
                    <el-option
                      v-for="option in number_type"
                      :key="option.label"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="form-group row" v-if="create.type == 3">
              <label
                for="pilot-main-ivr"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("number.pilot") }} *</label
              >
              <div class="col-md-10">
                <base-input
                  input-classes="form-control-alternative new-event--title"
                >
                  <el-select id="pilot-main-ivr"
                    v-model="create.main_ivr_id"
                    :placeholder="$t('number.pilot')"
                  >
                    <el-option
                      v-for="option in MainIVR"
                      :key="option.label"
                      :label="option.Number"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="form-group row" v-if="create.type == 3">
              <label for="pilot-alternative" class="col-md-2 col-form-label form-control-label">{{
                $t("number.alternative")
              }} *</label>
              <div class="col-md-10">
                <base-input id="pilot-alternative" placeholder="" v-model="create.alternative_number"></base-input>
              </div>
            </div>


            <div class="form-group row" v-if="create.type != 3">
              <label for="pilot-number" class="col-md-2 col-form-label form-control-label" v-if="create.type == 4">{{
                $t("number.real")
              }} *</label>
              <label for="pilot-number" class="col-md-2 col-form-label form-control-label" v-if="create.type != 4">{{
                $t("number.pilot")
              }} *</label>
              <div class="col-md-10">
                <base-input id="pilot-number" placeholder="" v-model="create.number"></base-input>
              </div>
            </div>

            <div class="form-group row" v-if="create.type != 3">
              <label for="pilot-charge" class="col-md-2 col-form-label form-control-label">{{
                $t("number.charge")
              }} *</label>
              <div class="col-md-10">
                <base-input id="pilot-charge"
                  placeholder=""
                  v-model="create.charge_number"
                ></base-input>
              </div>
            </div>

            <div class="form-group row" v-if="create.type != 3">
              <label
                for="email"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("email") }}</label
              >
              <div class="col-md-10">
                <base-input
                  placeholder=""
                  id="email"
                  v-model="create.email"
                />
              </div>
            </div>

            <div class="form-group row">
              <div
                class="col-md-2 col-form-label form-control-label"
              ></div>
              <div class="col-md-10">
                <base-button
                  id="example-search-input"
                  placeholder=""
                  class="btn btn-primary"
                  @click.native="handleCreate($index, row)"
                  type="primary"
                  size="md"
                  icon
                  >{{ $t("save") }}</base-button
                >
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "form-elements",
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    MainIVR(){
      // Pure derivation: filter the pilot list down to Main IVR rows for the
      // selected corporate. Do NOT mutate component state here — mutating
      // inside a computed can cause infinite update loops and clobbers user
      // input. The reset of create.main_ivr_id when corporate clears is
      // handled by the watch on create.corporate below.
      if (this.create.corporate != 0) {
        return this.tableDataOrg.filter((m)=>{
          return m.EnterpriseID ==  this.create.corporate && m.Type == 1
        });
      }
      return this.tableDataOrg
    },
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      corporate: "Corporate/getData",
      tableDataOrg: "PilotNumberV4/getData",
    })
  },
  watch: {
    'create.corporate'(newVal) {
      // When the corporate selection is cleared, reset the dependent
      // main_ivr_id field so stale IDs from a previous corporate don't leak.
      if (!newVal) {
        this.create.main_ivr_id = "";
      }
    }
  },

  data() {
    return {
      create: {
        corporate: null,
        number: "",
        charge_number: "",
        email: "",
        type: 1,
        alternative_number: "",
        main_ivr_id: "",
      },
      number_type : [
        {ID: 1 , Name :"Main IVR" },
        {ID: 3 , Name :"Alternative Number" },
        {ID: 4 , Name :"Real Number" },
        {ID: 5 , Name :"Additional IVR" },
      ],
    };
  },
  mounted() {
    this.listData();
    this.listCorporate();
  },
  methods: {
    ...mapActions({
      createData: "PilotNumberV4/createData",
      deleteData: "PilotNumberV4/deleteData",
      listCorporate: "Corporate/listData",
      listData: "PilotNumberV4/listData",
    }),
    handleCreate() {


      // alternate
      if (this.create.type == 3) {
        let main_ivr = this.tableDataOrg.filter((m)=>{
          return m.ID ==  parseInt(this.create.main_ivr_id)
        })
        // Guard: if no main IVR matches, bail with a warning instead of
        // dereferencing main_ivr[0].Number and throwing.
        if (main_ivr.length === 0) {
          swal.fire({
            title: this.$t("number.pilot"),
            text: this.$t("errors.subs.not_exist"),
            icon: "warning",
            confirmButtonClass: "btn btn-warning btn-fill",
            buttonsStyling: false
          });
          return;
        }
        this.create.number = main_ivr[0].Number
      }

      this.createData({
        enterpriseID: this.create.corporate,
        number: this.create.number,
        chargeNumber: this.create.charge_number,
        email: this.create.email,
        alternateNumber : this.create.alternative_number,
        subsType : this.create.type
      })
        .then(resp => {
          swal
            .fire({
              title: this.$t("number.create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              this.$router.push({ name: "pilot_number" });
            });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
